__turbopack_context__.v({
  "spin": "Oddy-module__WxVksG__spin",
  "spinSlow": "Oddy-module__WxVksG__spinSlow",
});
